/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cartPageActions from '../../../../services/Cart/actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import { getPlansData } from '../../../../utils/plansReference';
import DueMonthly from '../../../../components/Web/Cart/redesign/Components/FunctionalRedesign/dueMonthly';

const mapStateToProps = (state) => {
  const cartState = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo || {};
  const dueTodayList = state?.checkout?.lineDetails?.lineInfo?.newLine1 || {};
  const planState = state.homePlans ? state.homePlans.plansJson : {};
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const validCouponResponse = state.cartDetails?.validCouponResponse;
  const apiFailed = state.cartDetails?.apiFailed;
  const couponCodevalue = state.cartDetails?.couponCodevalue;
  const retrievecartResponse = state.cartDetails?.cartDetailsJson;
  const currentView = state.currentView || {
    currentStep: 'Cart',
    editPage: 'addons.html',
    editPlansPage: 'plansOverview.html',
    editPlansStep: 'PlansOverview',
    editStep: 'Addons',
    nextStep: 'ContactInfo',
    nextViewPage: 'contactinfo.html',
    previousStep: 'Setup',
  };
  const loader = state.loader || {};

  return {
    cartDetails: cartState || [],
    plansReferenceData: plansReferenceData || null,
    ltePlans: planState || null,
    loader,
    currentView,
    validCouponResponse,
    apiFailed,
    couponCodevalue,
    retrievecartResponse,
    dueTodayList,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartPageActions, ...loaderActions }, dispatch);
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(DueMonthly));
